import { Box, styled } from '@mui/material';

import { shouldForwardProps } from '../../utils/mui-styled.utils';

interface GridContainerProps {
	minCardWidth: number;
	gap?: number;
}

export const StyledCarouselGridContainer = styled(Box, {
	shouldForwardProp: shouldForwardProps(['minCardWidth', 'gap']),
})<GridContainerProps>(
	({
		theme: {
			palette: { sizes },
		},
		minCardWidth,
		gap,
	}) => ({
		display: 'grid',
		padding: `0  ${sizes.size_1}%`,
		gridTemplateColumns: `repeat(auto-fit, minmax(${minCardWidth}px, 1fr))`,
		gap: gap ? gap : sizes.size_2,
		justifyContent: 'center',
		alignItems: 'start',
		gridAutoFlow: 'row dense',
	}),
);
